<template>
  <w-settings-detail :title="title" :menu="menu" :default-active-menu="defaultMenu" @change="onChangeMenu">
    <component slot="activeView" :is="activeMenu" :activeView="activeMenu"></component>
  </w-settings-detail>
</template>

<script>
import WSettingsDetail from '@/components/template/SettingsDetail';
import WKeyTrsMainView from './key-transaction';
import WApplicationMainView from './application';
import WWasInstanceMainView from './instance';

const defaultMenu = 'WWasInstanceMainView';
export default {
  name: 'WConfigSettings',
  components: {
    WSettingsDetail,
    WKeyTrsMainView,
    WApplicationMainView,
    WWasInstanceMainView,
  },
  props: {
    title: String,
  },
  data() {
    return {
      defaultMenu,
      activeMenu: defaultMenu,
      menu: [
        {
          id: 'WWasInstanceMainView',
          name: 'WAS 인스턴스',
          active: false,
        },
        {
          id: 'WApplicationMainView',
          name: '어플리케이션',
          active: false,
        },
        {
          id: 'WKeyTrsMainView',
          name: '비즈니스',
          active: false,
        },
      ],
    };
  },
  methods: {
    onChangeMenu(menu) {
      this.activeMenu = menu;
    },
  },
};
</script>

<style scoped>
.apmbtn label {
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/apm/ConfigSettings/index.vue